import { TourDefinition } from '../types'

// No DOM exploration required — all steps target body or data-tour="profile-menu-button"
// which was added in base-layout.tsx for the welcome tour.

export let toursIntroTour: TourDefinition = {
  id: 'tours-intro',
  version: 1,
  name: 'Finding Your Tours',
  description: 'Learn how to retake tours or start new ones from your profile.',
  allowInLimited: true,
  steps: [
    {
      target: 'body',
      placement: 'center',
      title: "You've Completed Your First Tour!",
      content:
        'Nice work! The previous tour showed you how to complete your profile and enter your licenses/certifications. From here, completing courses will automatically track your CE hours and submit them to CAPCE and other supported organizations — no extra steps needed as long as you followed those steps.',
      disableBeacon: true,
    },
    {
      target: '[data-tour="profile-menu-button"]',
      placement: 'bottom',
      title: 'Find Your Tours Anytime',
      content:
        "You can retake any tour or start new ones from Profile → Tours. Click Done and we'll take you there now.",
      navigateTo: '/profile/tours',
    },
  ],
}
